import { createBrowserClient } from '@supabase/ssr';

// Singleton instance — prevents multiple clients from independently polling auth
// which would multiply the number of Supabase auth API calls and hit rate limits
let _client: ReturnType<typeof createBrowserClient> | null = null;

export function createClient() {
  if (_client) return _client;
  _client = createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
      },
    }
  );
  return _client;
}
